import { route } from "@circle-react/lib/routes/define";

export const memberTagRoutes = {
  list: route("/settings/member_tags", {
    title: "Member tags",
    requires: "admin",
    description: "Lists all member tags in the community's settings area.",
    queryParams: {
      page: {
        type: "number",
        description: "Pagination page number (default: 1).",
      },
      q: {
        type: "object",
        description: "Ransack search and sort params for the tags table.",
        properties: {
          name_i_cont: {
            type: "string",
            description: "Filters tags whose name contains this value.",
          },
          s: {
            type: "string",
            description:
              "Sort order: 'name asc', 'name desc', 'tagged_members_count asc', or 'tagged_members_count desc'.",
          },
        },
      },
    },
  }),

  new: route("/settings/member_tags/new", {
    title: "Create member tag",
    requires: "admin",
    description: "Form to create a new member tag.",
  }),

  edit: route("/settings/member_tags/:id/edit", {
    title: "Edit member tag",
    requires: "admin",
    description: "Edit form for a specific member tag.",
    pathParams: {
      id: {
        type: "number",
        description: "Numeric identifier of the member tag to edit.",
      },
    },
  }),
};
